var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMouse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Componente_106_19",
    "data-name": "Componente 106 \\u2013 19",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 69.694",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2679",
    "data-name": "Trazado 2679",
    d: "M17.5-35h-5A12.5,12.5,0,0,0,0-22.5v15A12.5,12.5,0,0,0,12.5,5h5A12.5,12.5,0,0,0,30-7.5v-15A12.5,12.5,0,0,0,17.5-35Zm10,27.5a10.019,10.019,0,0,1-10,10h-5a10.019,10.019,0,0,1-10-10v-15a10.019,10.019,0,0,1,10-10h5a10.019,10.019,0,0,1,10,10ZM15-28.75A3.757,3.757,0,0,0,11.25-25v2.5A3.751,3.751,0,0,0,15-18.75a3.751,3.751,0,0,0,3.75-3.75V-25A3.757,3.757,0,0,0,15-28.75Zm1.25,6.25A1.25,1.25,0,0,1,15-21.25a1.25,1.25,0,0,1-1.25-1.25V-25A1.25,1.25,0,0,1,15-26.25,1.25,1.25,0,0,1,16.25-25Z",
    transform: "translate(0 35)",
    fill: "#345eea"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2680",
    "data-name": "Trazado 2680",
    d: "M23.388-10.52l-.374-.374a.633.633,0,0,0-.9,0L12.709-1.482V-21.3a.635.635,0,0,0-.633-.633h-.527a.635.635,0,0,0-.633.633V-1.482L1.5-10.895a.633.633,0,0,0-.9,0l-.374.374a.633.633,0,0,0,0,.9L11.359,1.508a.633.633,0,0,0,.9,0L23.382-9.624A.629.629,0,0,0,23.388-10.52Z",
    transform: "translate(3 68)",
    fill: "#345eea"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouse);
export default __webpack_public_path__ + "static/media/mouse.242bbe9e346f2b0f69fb07534858fb50.svg";
export { ForwardRef as ReactComponent };